import React from "react";
import { array, object } from "prop-types";

import VideoCard from "./VideoCard";

const VideoList = ({ campaign, videos }) => {
  if (videos && videos.length > 0) {
    return (
      <div>
        {videos.map(video => (
          <VideoCard campaign={campaign} key={video.id} video={video} />
        ))}
      </div>
    );
  } else {
    return (
      <div className="col-md-12">
        <h3>Nenhum video para listar</h3>
      </div>
    );
  }
};

VideoList.propTypes = {
  campaign: object,
  videos: array
};

export default VideoList;



// WEBPACK FOOTER //
// ./src/components/VideoList.js